import React from 'react';
import { Navigate } from 'react-router-dom';
import { getToken } from '../services/auth';
import { jwtDecode } from 'jwt-decode';

function isAuthenticated() {
  const token = getToken();
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
